import $ from 'jquery';
import { useRef, useEffect } from 'react';
import { ModuleByName, ModuleClass, ModuleField } from './Componentes/ModuleLib';
export const serverURL = "https://www.educa.saludpublica.uchile.cl/cms/"

export const fetchApi = async (token: string, action: string, data?: any) => {
	//var resp = await Promise.resolve($.post(serverURL + "?act=" + action, data, null, "json"))
	var procesar = !(data instanceof FormData);
	if (data instanceof FormData) {
		procesar = false
		//if(!data.has("token"))
		data.set("token", token)
	}
	else {
		procesar = true
		if (!data) {
			data = { token: token }
		}
		else if (!data.token || data.token === "") {
			data.token = token;
		}
	}
	var resp = await Promise.resolve($.ajax({
		url: serverURL + "api/?act=" + action,
		data: data,
		processData: procesar,
		contentType: procesar ? undefined : false,
		dataType: 'json',
		type: 'POST'
	}))
	if (resp && resp.estado && resp.estado === "authError") {
		alert(resp.msg)
		localStorage.setItem("token", "")
		window.location.reload()
	}
	return resp;
}
export const filtro_unicos = (value: any, index: any, self: any) => { return self.indexOf(value) === index }
export const filtro_repetidos = (value: any, index: any, self: any) => { return self.indexOf(value) !== index }
export const range = (start: number, end: number) => Array.from({ length: (end - start) }, (v, k) => k + start);
export function useInterval(callback: Function, delay: number) {
	const savedCallback = useRef<Function>();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			if (savedCallback)
				savedCallback.current!()
		}
		if (delay !== null) {
			let id = setInterval(tick, delay);
			return () => clearInterval(id);
		}
	}, [delay]);
}
export const config_editor = {
	height: 300,
	//inline: true,
	language: 'es_MX',
	convert_urls: false,
	valid_elements: "*[*]",
	verify_html: false,
	plugins: [
		'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
		'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
		'insertdatetime', 'media', 'table', 'wordcount'
	],
	toolbar1: 'fullscreen code undo redo blocks  bold italic forecolor backcolor | image imageopts link unlink',
	toolbar2: 'alignleft aligncenter alignright alignjustify bullist numlist outdent indent removeformat',
	menubar: 'edit insert format tools table fullscreen',
	image_advtab: true,
	image_caption: false,
	object_resizing: true,
	resize_img_proportional: true,
	image_class_list: [
		{ title: "None", value: "" },
		{ title: "Fluid", value: "img-fluid w-100" },
		{ title: "Fluid <100", value: "img-fluid" }
	],
	content_css:$("link").prop("href")
}
export const getStructure = async (es: any) => {
	//var nueva = estructura
	var nueva = []

	for (var i = 0; i < es.length; i++) {
		var moduledata = es[i]
		var module = await ModuleByName(moduledata.module)

		var data = new Map<string, any>();
		for (var field in moduledata.data) {
			data.set(field, moduledata.data[field])
			// eslint-disable-next-line
			var f = module.getFields().filter((f: ModuleField) => f.name === field)
			if (f.length > 0) {
				f = f[0]
				if (f.initializeData) {
					data.set(field, await f.initializeData(moduledata.data[field]))
				}
			}
		}

		nueva.push({ Module: module, Data: data, Instance: i + 1 })
	}
	return nueva
}
export const getDefaultData = async (module: ModuleClass) => {
	var data = new Map<string, any>();
	module.getFields().forEach((field: ModuleField) => {
		data.set(field.name, field.default)
	})
	return data;
}
